import React, { useState, useEffect } from "react";
import { WhatsAppIcon } from "@/components/icons/WhatsAppIcon";
import { cn } from "@/lib/utils";
import { useLocation } from "react-router-dom";

const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const isProfessoresPage =
    location.pathname === "/areas-de-atuacao/professores-quinquenios" ||
    location.pathname === "/blog/acoes-para-professores";
  const isAposentadosPage =
    location.pathname === "/areas-de-atuacao/aposentados-e-pensionistas" ||
    location.pathname === "/blog/acoes-para-aposentados-e-pensionistas";
  const isImpostoDeRendaPage =
    location.pathname === "/areas-de-atuacao/imposto-de-renda" ||
    location.pathname === "/blog/imposto-de-renda";
  const isPoliciaisPage =
    location.pathname === "/areas-de-atuacao/policiais" ||
    location.pathname === "/blog/acoes-para-policiais";
  const isSaudePage =
    location.pathname === "/areas-de-atuacao/servidores-da-saude" ||
    location.pathname === "/blog/acoes-para-servidores-da-saude";

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isProfessoresPage) {
      window.dispatchEvent(new CustomEvent("open-professores-popup"));
    } else if (isAposentadosPage) {
      window.dispatchEvent(new CustomEvent("open-aposentados-popup"));
    } else if (isImpostoDeRendaPage) {
      window.dispatchEvent(new CustomEvent("open-imposto-popup"));
    } else if (isPoliciaisPage) {
      window.dispatchEvent(new CustomEvent("open-policiais-popup"));
    } else if (isSaudePage) {
      window.dispatchEvent(new CustomEvent("open-saude-popup"));
    } else {
      window.dispatchEvent(new CustomEvent("open-home-popup"));
    }
  };

  useEffect(() => {
    const toggleVisibility = () => {
      // Aparece após rolar uma tela inteira (segunda dobra), ou sempre na página /bio
      if (
        window.scrollY > window.innerHeight * 0.8 ||
        location.pathname === "/bio"
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    toggleVisibility();
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div
      className={cn(
        "fixed bottom-6 right-6 z-50 transition-all duration-500",
        isVisible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-8 pointer-events-none",
      )}
    >
      <div className="relative flex items-center">
        {/* Avatar circle hanging on the left edge */}
        <div className="relative -mr-5 z-20 flex-shrink-0">
          <div className="h-14 w-14 sm:h-16 sm:w-16 rounded-full border-2 border-[#25D366] p-0.5 bg-white shadow-md overflow-hidden">
            <img
              src="https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/691dcfaf88e1e632a985cfa2.jpg"
              alt="Atendimento"
              className="h-full w-full rounded-full object-cover"
              loading="lazy"
            />
          </div>
          {/* Online green indicator dot */}
          <span className="absolute bottom-0 right-0 h-3.5 w-3.5 rounded-full bg-[#25D366] border-2 border-white"></span>
        </div>

        {/* Card Box */}
        <div className="bg-white rounded-2xl shadow-2xl pl-7 pr-4 py-3 sm:py-3.5 border border-gray-100/80 max-w-[240px] sm:max-w-[260px] flex flex-col gap-2">
          <div>
            <h4 className="text-[14px] sm:text-[15px] font-bold text-gray-900 leading-tight">
              Converse conosco
            </h4>
            <p className="text-[11px] sm:text-[12px] text-gray-500 leading-snug mt-0.5">
              Atendimento pelo WhatsApp
            </p>
          </div>

          <a
            href="https://wa.me/5515997606362"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
            className="flex items-center justify-center gap-1.5 w-full rounded-lg bg-[#25D366] hover:bg-[#20bd5a] text-white py-2 px-3 text-xs sm:text-sm font-semibold shadow-sm transition-all duration-200 hover:shadow active:scale-[0.98]"
            aria-label="Chamar agora pelo WhatsApp"
          >
            <WhatsAppIcon className="h-4 w-4 fill-white" />
            <span>Chamar agora</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FloatingWhatsApp;
